import { render, staticRenderFns } from "./bankDetailsList.vue?vue&type=template&id=b35df752&scoped=true"
import script from "./bankDetailsList.vue?vue&type=script&lang=js"
export * from "./bankDetailsList.vue?vue&type=script&lang=js"
import style0 from "./bankDetailsList.vue?vue&type=style&index=0&id=b35df752&prod&lang=scss"
import style1 from "./bankDetailsList.vue?vue&type=style&index=1&id=b35df752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35df752",
  null
  
)

export default component.exports